module.exports = __webpack_public_path__ + "img/plant-icon.6da47b46.svg";